// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"styles__modalDialog___26_KO","modalContent":"styles__modalContent___35W_W"};